import { Injectable } from '@angular/core';
import { PagingData } from '../../../service/proxy';

@Injectable({
    providedIn: 'root'
})
export class InitializerService {

    createPagingData(): PagingData {
        return {
            pageNo: 1,
            pageSize: 10,
            sortDirection: 'Asc',
            sortColumn: 'Id'
        } as PagingData;
    }
}